export default __webpack_public_path__ + "static/media/triangle.4de8b323.svg";